import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './GallectionsEmptyState';
import { AppState } from '../../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../selectors/users';
import { getGallectionSectionType } from '../../../../selectors/gallectionSection';

export type StateProps = Pick<
  Props,
  'isOwner' | 'gallectionType' | 'ownerUsername'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isOwner: isCurrentUserProfileOwner(state),
  gallectionType: getGallectionSectionType(state),
  ownerUsername: getProfileOwnerUser(state).username,
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
